export const exportToJson = (data, filename) => {
  const jsonStr = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonStr], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const exportToCsv = (data, filename) => {
  // CSV fejlécek meghatározása az első elem alapján
  const headers = Object.keys(data[0] || {});
  
  // CSV sorok létrehozása
  const csvRows = [
    headers.join(','), // Fejléc sor
    ...data.map(row => 
      headers.map(header => {
        const value = row[header];
        // Ha az érték objektum, akkor JSON stringként mentjük
        const cellValue = typeof value === 'object' ? JSON.stringify(value) : value;
        // Idézőjelek közé tesszük és escapeljük a vesszőket
        return `"${cellValue?.toString().replace(/"/g, '""')}"`; 
      }).join(',')
    )
  ];

  const csvString = csvRows.join('\n');
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}; 